<template>
  <div style="width: 1200px;margin: 0 auto;height: 100%" class="xh">
    <el-tabs :tab-position="tabPosition" v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="协会简介" name="first">
        <!-- <div style="font-size: 18px;font-weight: bold;">{{ introductiontitle }}</div> -->
        <div style="padding-left: 50px">
        <div class="pa" style="padding-bottom: 20px;font-size: 14px;text-align: justify" v-html="introductioncontent">
        </div>
      </div>
      </el-tab-pane>
      <el-tab-pane label="服务范围" name="second">
        <!-- <div style="font-size: 18px;font-weight: bold;">{{ rangetitle }}</div> -->
        <div style="padding-left: 50px">
        <div class="pa" style="padding-bottom: 20px;font-size: 14px;text-align: justify" v-html="rangecontent"></div>
      </div>
      </el-tab-pane>
      <el-tab-pane label="主要业绩" name="third">
        <!-- <div style="font-size: 18px;font-weight: bold;">{{ performancetitle }}</div> -->

        <!--      <div style="padding-bottom: 20px;padding-top: 30px;font-size: 14px;text-align: justify;text-indent:2em;line-height: 40px" v-html="performancecontent.replace(/\n/g,'<br/>')"></div>-->
        <div style="padding-left: 50px">
        <div class="pa" style="padding-bottom: 20px;font-size: 14px;text-align: justify" v-html="performancecontent">
        </div>
      </div>
      </el-tab-pane>
      <el-tab-pane label="公示公告" name="fourth">
        <div style="padding-left: 50px">
          <div
            v-for="(item, index) in opencontent.slice((this.query.currentPage - 1) * this.query.pagesize, this.query.currentPage * this.query.pagesize)"
            :key="index">
            <div class="content">
              <div class="pi">
                <router-link :to="{ path: 'Newsparticulars', query: { id: item.id } }">{{ item.title }}</router-link>
              </div>
              <div>
                <p>{{ item.update_time }}</p>
              </div>
            </div>
          </div>
        </div>
          <!--分页区域-->
          <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
            :current-page="query.currentPage" :page-sizes="[10, 20, 30]" :page-size="query.pagesize"
            layout="total, sizes, prev, pager, next, jumper" :total="total2
              ">
          </el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Utils from '../../assets/js/util.js';
export default {
  name: "Survey",
  data() {
    return {
      tabPosition: 'left',
      activeName: 'first',
      introductiontitle: '',
      introductioncontent: '',
      rangetitle: '',
      rangecontent: '',
      performancetitle: '',
      performancecontent: '',
      opentitle: '',
      opencontent: [],
      query: {
        currentPage: 1,//当前页数
        pagesize: 10,//每页显示条目个数
      },
      total2: 0,
    }
  },
  mounted() {
    let that = this;
    Utils.$on('demo', function (msg) {
      console.log(msg)
      if (msg == '2-1') {
        that.activeName = "first";
        that.handleClick(that.activeName)
      } else if (msg == '2-2') {
        that.activeName = "second";
        that.handleClick(that.activeName)
      } else if (msg == '2-3') {
        that.activeName = "third";
        that.handleClick(that.activeName)
      } else if (msg == '2-4') {
        that.activeName = "fourth";
        that.handleClick(that.activeName)
      }
    });
    let name = sessionStorage.getItem('currentTab')
    // 判断是否存在currentTab，即tab页之前是否被点击切换到别的页面
    if (name) {
      this.activeName = name
    }

  },

  beforeRouteLeave(to, from, next) {
    // 在离开此路由之后清除保存的状态（我的需求是只需要在当前tab页操作刷新保存状态，路由切换之后不需要保存）
    // 根据个人需求决定清除的时间
    sessionStorage.removeItem('currentTab')
    next()
  },
  created() {
    let a = this.$route.query.act;
    if (a == 'first') {
      this.activeName = "first";
      this.handleClick(this.activeName)
    } else if (a == 'fourth') {
      this.activeName = "fourth";
      this.handleClick(this.activeName)
    }
    this.introduction();
    //this.range();
    //this.performance();
    //this.open();
  },
  methods: {
    /*协会简介*/
    introduction() {
      let params = {}
      this.axios.post('/api/index/introductionList', params).then((response) => {
        console.log(response)
        if (response.data.msg == 'success') {
          this.introductiontitle = response.data.data.message
          this.introductioncontent = response.data.data.value
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    /*服务范围*/
    range() {
      let params = {}
      this.axios.post('/api/index/range', params).then((response) => {
        console.log(response)
        if (response.data.msg == 'success') {
          this.rangetitle = response.data.data.message
          this.rangecontent = response.data.data.value
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    /*主要业绩*/
    performance() {
      let params = {}
      this.axios.post('/api/index/performanceList', params).then((response) => {
        console.log(response)
        if (response.data.msg == 'success') {
          this.performancetitle = response.data.data.message
          this.performancecontent = response.data.data.value
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    /*信息公开*/
    open() {
      this.axios.post('/api/index/openList', this.query).then((response) => {
        console.log(response)
        this.opencontent = response.data.data.data
        this.total2 = response.data.data.total
        // for (var i=0;i<response.data.data.data.length;i++) {
        //   var time = response.data.data.data[i].create_time
        //   var timearr = time.replace(" ", ":").replace(/\:/g, "-").split("-");
        //   var nian = timearr[0];
        //   var yue = timearr[1];
        //   var ri = timearr[2];
        //   this.opencontent.push({
        //     id: response.data.data.data[i].id,
        //     title: response.data.data.data[i].title,
        //     message: response.data.data.data[i].message,
        //     month: yue,
        //     day: ri,
        //     nian: nian,
        //     pageViews: response.data.msg
        //   })
        // }

      }).catch(function (error) {
        console.log(error);
      });
    },
    handleClick(tab) {
      console.log(tab)
      if (tab === 'first') {
        //this.introduction();
      } else if (tab === 'second') {
        this.range()
      } else if (tab === 'third') {
        this.performance()
      } else if (tab === 'fourth') {
        this.open()
      }

      // 点击tab后触发事件，修改显示页面，将状态保存在sessionStorage里面
      //sessionStorage.setItem('currentTab', tab.name)
    },
    handleTabClick(tab) {
      if (tab.name === 'first') {
        this.introduction();
      } else if (tab.name === 'second') {
        this.range()
      } else if (tab.name === 'third') {
        this.performance()
      } else if (tab.name === 'fourth') {
        this.open()
      }
      // 点击tab后触发事件，修改显示页面，将状态保存在sessionStorage里面
      sessionStorage.setItem('currentTab', tab.name)
    },
    //监听 pagesize 改变的事件
    handleSizeChange2(newSize) {
      this.query.pagesize = newSize
      this.open()
    },
    //监听 页码值 改变的事件
    handleCurrentChange2(newPage) {
      this.query.currentPage = newPage
      this.open()
    },
  }
}
</script>

<style scoped>
.xh>>>.el-tabs__nav-wrap::after {
  position: static !important;
}

.xh>>>.el-tabs__active-bar {
  background-color: transparent !important;
}

.pa /deep/ p {
  /* margin-top: 0px; */
  margin-bottom: 0px;
}

.pi {
  /*float: left;*/
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 18px;
  text-align: left;
  cursor: pointer;

}

.content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px dashed #ccc;
}

a {
  text-decoration: none;
  color: black;
}

.pi a:hover {
  color: #2F93b7 !important;

}</style>



// WEBPACK FOOTER //
// src/components/view/Survey.vue